"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSchematicDrawing = addSchematicDrawing;
const Utils_1 = require("@cadstrom/sigma-engine-shared/dist/Utils");
function addSchematicDrawing(model, layer, drawing) {
    if (!model.drawings[layer]) {
        model.drawings[layer] = [...(0, Utils_1.toArray)(drawing)];
    }
    else {
        model.drawings[layer].push(...(0, Utils_1.toArray)(drawing));
    }
}
//# sourceMappingURL=schematicUtils.js.map